import { getToken } from 'actions/sessionActions';
import history from '../history';

export class AnalyticsDashboardError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

const getMonitoraBaseUrl = () => {
  const base = process.env.REACT_APP_API_MONITORA || '';
  return base.replace(/\/$/, '');
};

const normalizeJwt = (raw) => {
  if (raw == null) return '';
  let token = raw;
  if (typeof token === 'string' && token.startsWith('"')) {
    try {
      token = JSON.parse(token);
    } catch {
      token = token.replace(/^"|"$/g, '');
    }
  }
  return String(token).replace(/^Bearer\s+/i, '').trim();
};

export const buildAnalyticsQuery = ({
  applicationId,
  from,
  to,
  companyId,
  unitId,
  limit,
}) => {
  const query = { applicationId };
  if (from) query.from = from.toISOString();
  if (to) query.to = to.toISOString();
  if (companyId) query.companyId = companyId;
  if (unitId) query.unitId = unitId;
  if (limit != null) query.limit = limit;
  return query;
};

export async function fetchAnalyticsDashboard(path, query) {
  const base = getMonitoraBaseUrl();
  if (!base) {
    throw new AnalyticsDashboardError('REACT_APP_API_MONITORA não configurada.', 0);
  }

  const url = new URL(`${base}${path}`);
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value != null && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });

  const jwt = normalizeJwt(getToken());
  if (!jwt) {
    throw new AnalyticsDashboardError('Sessão expirada.', 401);
  }

  const response = await fetch(url.toString(), {
    headers: {
      Authorization: `Bearer ${jwt}`,
      token: jwt,
      Accept: 'application/json',
    },
  });

  let body = {};
  try {
    body = await response.json();
  } catch {
    body = {};
  }

  if (response.status === 401) {
    history.push('/auth/login');
    throw new AnalyticsDashboardError(body.status || body.error || 'Não autorizado.', 401);
  }

  if (!response.ok) {
    const message = body.status || body.error || body.message || response.statusText;
    throw new AnalyticsDashboardError(message, response.status);
  }

  return body;
}
